import "../styles/register.scss";
import {
  TextField,
  Alert,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function RetreatQs() {
  const url = "https://dev.pmwwebdesign.com";
  // const url = "http://localhost:3999";
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  // !ALERTS
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("");

  const preCheck = () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^[0-9]*$/
    if (name === "" || lastName === "" || phone === "" || email === "" ){
      setMessage('All details need filled in')
      setSeverity('warning')
      setShowAlert(true)
      setTimeout(() => {
        setShowAlert(false)
      },2500)
    }else if (!email.match(regex)) {
      setMessage("Email is the wrong format");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else if (!phone.match(phoneRegex)) {
      setMessage("Phone should be only numbers");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else{
      submit()
    }
  }

  const submit = () => {
    const data = {
      firstName: name,
      lastName: lastName,
      phone: phone,
      email: email
    }
    axios.post(`${url}/mastermind/retreat-interest`, data)
    .then((res) => {
      console.log(res.data)
      navigate('/thank-you?form=true')
    }).catch((err) => {
      console.log(err)
      setMessage("Something went wrong, please try again");
      setSeverity("error");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    })
  };

  return (
    <main className="register">
      <h2>Provide your details to register interest on the retreat</h2>
      <section className="form">
        <section className="form__row">
          <TextField
            id="outlined-basic"
            label="First Name"
            variant="outlined"
            className="text--field"
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            id="outlined-basic"
            label="Last Name"
            variant="outlined"
            className="text--field"
            onChange={(e) => setLastName(e.target.value)}
          />
        </section>
        <section className="form__row">
          <TextField
            id="outlined-basic"
            label="Email"
            variant="outlined"
            className="text--field"
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            id="outlined-basic"
            label="Phone Number"
            variant="outlined"
            className="text--field"
            onChange={(e) => setPhone(e.target.value)}
          />
        </section>
        {showAlert ? (
        <Alert severity={severity}>{message}</Alert>
      ) : (
        <buttom className="app__button" onClick={preCheck}>
          Submit
        </buttom>
      )}

      </section>
    </main>
  );
}
